import api from './api';
import convertOptions from '../util/convertOptions';
import { LISTA_BANCOS } from '../constants/mocks'

const getLinkImages = async () => {
  const client = await api('bfconsig');
  const { data } = await client.get('aplicacoes/link-images');
  return data[0] ? data[0].parametros : {};
};

const getMenuItens = async () => {
  const client = await api('corporate');
  const { data } = await client.get('menu');
  return data ? data : [];
};

const getBancos = async () => {
  return convertOptions(LISTA_BANCOS, 'Id', 'Nome');
};

export { getLinkImages, getBancos, getMenuItens };
